const wrapper = "_0mwqfn19i";
const icon = "_0mi17x0rkj";
const headingBar = "_0mha64hbk";
const descriptionBar = "_0md15pffsd";
const chevron = "_0mcmfd894";

export { chevron, descriptionBar, headingBar, icon, wrapper };
import "./_card.style.linaria.module.css";
//# sourceMappingURL=_card.style.js.map
